import { jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx("path", { d: "M21 3H18V1H16V3H8V1H6V3H3V21H21V3ZM19 19H5V8H19V19ZM7 10H12V15H7V10Z", fill: "currentColor", fillOpacity: 0.9 }) });
export default SvgCalendar;
